
export const ADMIN_TYPE = [
    {
        id: 0,
        name: 'Chấm thi',
    },
    {
        id: 1,
        name: 'Gia sư',
    },
    {
        id: 2,
        name: 'Test đầu vào',
    }
];

export const ADMIN_TYPE_TAG = {
    0: 'success',
    1: 'info',
    2: 'warning',
}

export const TYPE_WORK = [
    {
        id: 0,
        name: 'Tất cả',
    },
    {
        id: 1,
        name: 'Online',
    },
    {
        id: 2,
        name: 'Offline',
    }
];

export const TYPE_WORK_TAG = {
    0: 'success',
    1: 'info',
    2: 'warning',
}

export const STATUS = [
    {
        id: 1,
        name: 'Hiển thị',
    },
    {
        id: 0,
        name: 'Ẩn',
    },
]

export const STATUS_TAG = {
    0: 'danger',
    1: 'success',
}





